
import ArrangeCircle from "../../../assets/outline/ArrangeCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrangeCircleIcon({ className, dataTestid = "ArrangeCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrangeCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
